const {createTheme} = require("@material-ui/core");
const {purple, green} = require("@material-ui/core/colors");
const breakpoints = {
    values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
    },
};
const theme = createTheme({
    breakpoints,
    typography: {
        fontFamily: 'Roboto, Arial',
        body1:{
            color: '#fff',
        },
        h1:{
            fontFamily: 'Roboto',
            color: '#fff',
            textTransform:'uppercase',
            fontSize: '48px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '1',
            letterSpacing: '0.11267313361167908px',
            textAlign: 'left',
            [`@media screen and (max-width: ${breakpoints.values.sm}px)`]: {
                fontSize: "32px",
            }
        },
        h2:{
            fontFamily: 'Roboto',
            color: '#fff',
            textTransform:'uppercase',
            fontSize: '24px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '37px',
            letterSpacing: '0.11267313361167908px',
            textAlign: 'left',
            [`@media screen and (max-width: ${breakpoints.values.sm}px)`]: {
                fontSize: "18px"
            }
        },
        h3:{
            fontFamily: 'Roboto',
            color: '#fff',
            textTransform:'uppercase',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '24px',
            letterSpacing: '0.11267313361167908px',
            textAlign: 'left',
            [`@media screen and (max-width: ${breakpoints.values.sm}px)`]: {
                fontSize: "14px"
            }
        },
        p:{
            fontFamily: 'Manrope',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '24px',
            letterSpacing: '0.11267313361167908px',
            [`@media screen and (max-width: ${breakpoints.values.sm}px)`]: {
                fontSize: "14px"
            }
        },
        overline:{
            fontFamily: 'Manrope',        //Manrope
            color: '#fff',
            fontSize: '16px',
            textTransform: 'none'
        },
        subtitle1:{
            fontSize: '16px',
            fontFamily: 'Manrope',
            [`@media screen and (max-width: ${breakpoints.values.sm}px)`]: {
                fontSize: "14px"
            }
        }
    },

    /*components: {
        MuiCssBaseline: {
            styleOverrides: `
        @font-face {
          font-family: 'Raleway';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Raleway'), local('Raleway-Regular'), url(${RalewayWoff2}) format('woff2');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
        },
    },*/
    body: {
        font: {
            primary: 'Manrope'
        },    
    },
    palette: {
        background: {
            default: '#000',
            primary: '#191919',
            secondary: '#111111',
            hover: 'rgba(255, 255, 255, 0.2)'
        },
        border: {
            primary: '1px solid rgba(145, 158, 171, 0.32)'
        },
        text: {
            primary: "#fff"
        },
        button:{
            primary: "#fff",
            secondary: 'rgb(255 255 255 / 16%)',
            disable: 'rgba(255, 255, 255, 0.4)',
        },
        primary: {
            main: '#fff',
        },
        secondary: {
            main: '#ED1C24',
            '&:hover': {
                main: '#FF454C'
            }
        },
        drawer: {
            default: 'rgba(12, 12, 12, 0.95)'
        },
        fill: {
            color: '#fff',
        },
        divider: 'rgba(255, 255, 255, 0.1)',
    },
});
export default theme;